import React from 'react';

export default function Footer() {
    return (
        <div className="flex flex-col sm:mt-5 items-center justify-center text-white font-['Fira_Sans']">
            <div className='font-bold text-xs sm:text-xs '>Made with ReactJS and TailwindCSS</div>
            <div className='mt-1 mb-1 text-xs sm:text-xs '>© Joel Lim 2025</div>
        </div>
    );
}
